<template>
    <FormContainer @submitForm="saveCrediti">
    <div class="row">
      <FormInputTextWidget
        class="col-lg-4 col-sm-6"
        label="Nome"
        v-model="credito.name"
        :errorMsg="errorHash['name']"
        @input="removeError('name')"
      />

      <FormInputMonthPickerWidget
        class="col-lg-4 col-sm-6"
        label="Mese"
        not-required
        v-model="credito.month"
        :errorMsg="errorHash['month']"
        @input="removeError('month')"
      />

      <FormInputAmountWidget
        class="col-lg-4 col-sm-6"
        label="Importo"
        v-model.number="credito.importo"
        :min="0"
        :errorMsg="errorHash['amount']"
        @input="removeError('amount')"
      />
    </div>

    <div class="row">
      <div class="col-12 mt-4 text-center text-sm-right">
        <button class="btn btn-primary" type="submit">
          <i class="fas fa-save mr-2"></i>
          Salva credito
        </button>
      </div>
    </div>
  </FormContainer>
</template>

<script>

import validateMixin from '@/libs/Form/mixins/validate';

export default {
  mixins: [validateMixin],
  components: {
    FormContainer: () => import('@/libs/Form/components/FormContainer'),
    FormInputTextWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputTextWidget'),
    FormInputAmountWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputAmountWidget'),
    FormInputMonthPickerWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputMonthPickerWidget'),
  },
  props: {
    credito: {
      type: Object,
      default: () => ({
        name: null,
        month: null,
        importo: null,
      }),
    },
    edit: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    validate () {
      this.clearErrors();

      if (!this.credito.name) {
        this.addError('Il nome del credito è obbligatorio', 'name');
      }

      if (!this.credito.month) {
        this.addError('Il campo mese è obbligatorio', 'month');
      }

      if (!this.credito.importo) {
        this.addError('Il campo importo è obbligatorio', 'amount');
      }

      return !this.hasErrors;
    },
    saveCrediti () {
      if (!this.validate()) {
        return;
      }

      this.$emit('saved', this.credito);
    },
  },
};

</script>
